import React, { useMemo } from 'react'
import { useFormikContext } from 'formik'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'
import { containsAll, containsAny } from 'utils/utils'
import PrivilegeTooltipWrapper from '../PrivilegeTooltipWrapper/PrivilegeTooltipWrapper'

export default function SelectAllInModuleCheckbox ({
  modulePrivileges,
  onModuleCheckboxClick,
  getPrivilegesBlockingUnchecking,
}) {
  const { values } = useFormikContext()

  const isEveryModulePrivilegeSelected = containsAll(modulePrivileges, values.privileges)

  const { privilegesBlockingUnchecking, privilegesBlockedByOnesOutsideModule } = useMemo(() => {
    const privilegeToBlockingPrivilegesOutsideModule = modulePrivileges
      .map(privilege => ({
        privilege,
        blockingPrivileges: getPrivilegesBlockingUnchecking([privilege]).filter(p => !modulePrivileges.includes(p))
      }))
      .filter(p => p.blockingPrivileges.length > 0)
    return {
      privilegesBlockingUnchecking: privilegeToBlockingPrivilegesOutsideModule.flatMap(p => p.blockingPrivileges),
      privilegesBlockedByOnesOutsideModule: privilegeToBlockingPrivilegesOutsideModule.map(p => p.privilege)
    }
  }, [modulePrivileges, getPrivilegesBlockingUnchecking])

  return (<PrivilegeTooltipWrapper show={privilegesBlockingUnchecking?.length > 0}
                                   privileges={privilegesBlockingUnchecking}>
      <div>
        <PrimaryCheckbox
          checked={isEveryModulePrivilegeSelected}
          indeterminate={!isEveryModulePrivilegeSelected && containsAny(modulePrivileges, values.privileges)}
          onClick={event => onModuleCheckboxClick(event, modulePrivileges.filter(p => !privilegesBlockedByOnesOutsideModule.includes(p)))}/>
      </div>
    </PrivilegeTooltipWrapper>
  )
}